import { render, staticRenderFns } from "./ContentFeedPreview.vue?vue&type=template&id=2a1bdc98&scoped=true&"
import script from "./ContentFeedPreview.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedPreview.vue?vue&type=style&index=0&id=2a1bdc98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1bdc98",
  null
  
)

export default component.exports